import * as less from './About.less';
import React from 'react';
import WindowResizeComponent from '../components/WindowResizeComponent';
import logoImg from '../assets/images/radio-kangol-logo-black.svg';

export default class About extends WindowResizeComponent() {
  constructor(props, context) {
    super(props, context);

    this.slideDown = this.slideDown.bind(this);
  }

  slideDown(e) {
    e.preventDefault();

    const content = React.findDOMNode(this.refs.aboutContent);
    const destination = $(content).offset().top;
    $('html, body').animate({
      scrollTop: destination
    }, 150);
  }

  render() {
    const imageStyles = {
      height: this.state.windowHeight
    };

    const logoStyles = {
      top: (this.state.windowHeight - 94) / 2
    };

    return (
      <div className='page-about-container'>
        <div className='about-header' style={imageStyles}>
          <div className='about-logo' style={logoStyles}></div>
          <div className='about-arrow'><a href='#' onClick={this.slideDown}>Go to Content</a></div>
        </div>
        <div ref='aboutContent' className='about-content-logo'>
          <a href='http://www.kangol.com' target='_blank'><img src={logoImg} width='70px'/></a>
        </div>
        <div className='about-content'>
          <p>In 1985 L.L. Cool J rapped a ballad about his radio, he couldn’t live without it, or his Kangol. Rap music spread from New York on the global radiowaves redefining the world’s pop culture and washing a wave of Kangol crowns onto the kings and queens of Generation X.</p>

          <p>As the nineties became the noughties, the rewind gave way to the download, as our bandwidth got ever greater, our headphones plugged into our cellphones, podcasts emerged, and the evolution became the revolution. The digital generation continually flocks to radio for true music discovery and streaming.</p>

          <p>Enter, Radio Kangol. To reignite the Kangol love affair with music, Kangol has partnered with underground labels from around the globe and across all genres to create a new digital experience built for music lovers. Kangol has been lucky enough to grace stages of all sizes and is honored to now have its own platform to bring artists center stage.</p>
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/routes/About.jsx
 **/